import React from 'react'
import { graphql } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import Description from '../../ui/description'
import OfferMedias from './offerMedias'
import { Button } from '../../ui'
import ButtonColor from '../../ui/buttonColor'
import { useApplyStore } from '../../../stores/ui/applyStore'

type DescriptionsProps = {
  offerId?: string
  descriptions: {
    missions: string | null
    needs: string | null
    workWithUs: string | null
    prospects: string | null
    process: string | null
  }
  offerMedias: IGatsbyImageData[] | string[] | null
  companyName: string | null
  isCareerSite?: boolean
  colorCareerSite?: string | null
  positionFilled?: boolean
}

const Descriptions: React.FC<DescriptionsProps> = ({
  descriptions,
  offerId,
  offerMedias = [],
  companyName,
  isCareerSite = false,
  positionFilled = false,
  colorCareerSite = null,
}) => {
  const { openApplicationFormModal } = useApplyStore()

  return (
    <div className="container mx-auto space-y-4">
      {descriptions.missions && (
        <Description
          data={descriptions.missions}
          label="Description du poste"
        />
      )}
      {offerMedias?.length && (
        <OfferMedias medias={offerMedias} companyName={companyName} />
      )}
      {!positionFilled && (
        <div className="flex justify-center mx-auto">
          {isCareerSite && colorCareerSite ? (
            <ButtonColor
              label="Postuler"
              invert
              color={colorCareerSite || 'null'}
              size="lg"
              onClick={() =>
                openApplicationFormModal({
                  offerId,
                  isCareerSiteApply: isCareerSite,
                  colorCareerSite: colorCareerSite || undefined,
                })
              }
            />
          ) : (
            <Button
              label="Postuler"
              invert
              color="primary"
              size="lg"
              onClick={() =>
                openApplicationFormModal({
                  offerId,
                })
              }
            />
          )}
        </div>
      )}
      {descriptions.needs && (
        <div className="mt-4">
          <Description
            data={descriptions.needs}
            label="Ce que le poste nécessite"
          />
        </div>
      )}
      {descriptions.workWithUs && (
        <div className="mt-4">
          <Description
            data={descriptions.workWithUs}
            label="Travailler chez nous ca veut dire quoi ?"
          />
        </div>
      )}
      {descriptions.prospects && (
        <div className="mt-4">
          <Description
            data={descriptions.prospects}
            label="Les perspectives chez nous"
          />
        </div>
      )}
      {descriptions.process && (
        <div className="mt-4">
          <Description
            data={descriptions.process}
            label="Le process de recrutement"
          />
        </div>
      )}
    </div>
  )
}

export default Descriptions

export const query = graphql`
  fragment OfferDescriptions on STRAPI__COMPONENT_OFFER_DESCRIPTION {
    missions {
      data {
        missions
      }
    }
    needs {
      data {
        needs
      }
    }
    process {
      data {
        process
      }
    }
    prospects {
      data {
        prospects
      }
    }
    workWithUs {
      data {
        workWithUs
      }
    }
  }
`
